import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import { toast } from 'react-toastify';
import axios from 'axios';
import LoadingComponent from '../../../layouts/nav/loading';

const EditArea = ({ show, onClose, branch, name, onSuccess }) => {

    const [groupedarea, setGroupedarea] = useState({});
    const [area, setarea] = useState([]);
    const [areaadd, setareaadd] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        if (branch) {
            axios.get(`${baseURL}/dropdown/get_branch_area/${branch}`)
            .then(response => {
                setGroupedarea(response.data.data);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });
        }
    }, [branch]);

    useEffect(() => {
        if (!Array.isArray(groupedarea)) {
            // console.log("area is not an array:", groupedarea);
            return;
        }

        const grouped = groupedarea.reduce((acc, item) => {
            const branchName = item.branch_data.branch_name;
            if (!acc[branchName]) {
                acc[branchName] = {
                    branch_name: branchName,
                    area: [],
                    branch_data: item.branch_data
                };
            }
            acc[branchName].area.push({
                area_name: item.area_name,
                sno: item.sno,
                status: item.status,
                assigned_delivery_point: item.assigned_delivery_point
            });
            return acc;
        }, {});

        const firstGroup = Object.values(grouped)[0];
        setarea(firstGroup);
        // console.log(firstGroup);
    }, [groupedarea]);

    useEffect(() => {
            
        // console.log("Branch Data:", area); 
        // console.log("Branch Name:", area?.branch_data?.branch_name);
        if (area?.area && Array.isArray(area.area)) {
            setareaadd(
            area.area.map((a) => ({
                id: a.sno || Date.now(), 
                sno: a.sno,
                area_name: a.area_name || '',
                status: Number(a.status) || 0,
                dp: a.assigned_delivery_point
            }))
            );
            setErrors({});
        } else {
            
            setareaadd([{ id: Date.now(), area_name: '', status: 0, dp: 0 }]);
            setErrors({});
        }
    }, [area]);

    const handleAddConfig = () => {
        setareaadd([...areaadd, { id: Date.now(), area_name: '', status: 0, dp: 0 }]);
        setErrors((prev) => ({ ...prev, [Date.now()]: '' }));
    };

    const handleDeleteArea = async (id, sno) => {
        try {
            if (sno) {
                // console.log(`Deleting area with sno: ${sno}`);
                await axios.delete(`${baseURL}/managearea/${sno}`);
            }

            setareaadd(prev => prev.filter(a => a.id !== id));
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[id];
                return newErrors;
            });
            // onSuccess();
            // alert("Area deleted successfully.");
        } catch (error) {
            console.error("Failed to delete area:", error);
            // alert("Failed to delete area. Please try again.");
        }
    };


    const handleChange = (id, value) => {
        setareaadd((prev) =>
        prev.map((a) => (a.id === id ? { ...a, area_name: value } : a))
        );
        // Clear error for this field when user types
        setErrors((prev) => ({
        ...prev,
        [id]: value.trim() ? '' : prev[id],
        }));
    };

    const handleCancel = () => {
        setareaadd([{ id: Date.now(), area_name: '' }]); // Reset form fields to default
        setErrors({});
        onClose();  // Close the modal after resetting
    };

    const toggleStatus = async (id, sno, currentStatus) => {
    const newStatus = currentStatus === 0 ? 1 : 0;
    try {
        await axios.put(`${baseURL}/managearea/status/${sno}`, { status: newStatus });
        setareaadd(prev =>
        prev.map(a =>
            a.id === id ? { ...a, status: newStatus } : a
        )
        );
        // onSuccess();
    } catch (error) {
        console.error("Failed to update status:", error);
        // alert("Failed to update status. Please try again.");
    }
    };
    
    const handleSubmit = async () => {
        const newErrors = {};
        let hasError = false;

        // Trimmed version first
        const trimmedAreas = areaadd.map((a) => ({
            ...a,
            area_name: a.area_name.trim(),
        })).filter((a) => a.area_name !== '');

        // 1. Required field validation
        areaadd.forEach((a) => {
            if (!a.area_name.trim()) {
                newErrors[a.id] = 'This field is required';
                hasError = true;
            }
        });

        // 2. Duplicate name validation (case-insensitive)
        const nameMap = {};
        trimmedAreas.forEach((a) => {
            const nameKey = a.area_name.toLowerCase();

            if (nameMap[nameKey]) {
                newErrors[a.id] = 'Area name already exists';
                newErrors[nameMap[nameKey]] = 'Area name already exists';
                hasError = true;
            } else {
                nameMap[nameKey] = a.id;
            }
        });

        if (trimmedAreas.length === 0) {
            newErrors.no = 'Please Enter At Least One Area.';
            hasError = true;
            // alert('Please enter at least one area name.');
            // return;
        }
        setErrors(newErrors);

        if (hasError) return;
        setLoading(true);

        const existingAreas = trimmedAreas.filter((a) => a.sno);      
        const newAreas = trimmedAreas.filter((a) => !a.sno);          

        try {
            await Promise.all(
                existingAreas.map((a) =>
                    axios.put(`${baseURL}/managearea/${a.sno}`, {
                        branch_name: area.branch_data.sno,
                        area_name: a.area_name,
                        status: a.status,
                    })
                )
            );

            await Promise.all(
                newAreas.map((a) =>
                    axios.post(`${baseURL}/managearea`, {
                        branch_name: branch,
                        area_name: a.area_name,
                        status: a.status,
                    })
                )
            );

            toast.success("Areas Updated successfully!");
            onSuccess();
            onClose();
            setLoading(false);
        } catch (error) {
            console.log('Update failed:', error);
            // const errorMessage = error.response?.data?.message || 'Failed to update areas. Try again.';
            toast.error("Failed to update areas. Please try again.");
        }
    };

    return (
        <Modal show={show} size="md">
            <LoadingComponent loading={loading} />
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Add Area</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="mb-2">
                            <label className="col-12 text-black fs-7">Branch</label>
                            <label className="col-12 text-red font-w500 fs-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{name ? name : '-'}</label>
                        </div>
                        <div className="col-lg-12 mb-3">
                            <div className='row'>
                                <div className='scroll-y mh-350px py-2'>
                                    <div className="col-lg-12 mb-3">
                                        <div className="mb-3">
                                            {areaadd.map(config => (
                                                <div key={config.id} data-repeater-item>
                                                    <div className="row">
                                                        <div className='col-lg-8 col-xs-8 mb-2'>
                                                            <label className="text-black font-w500 fs-7">Area <span className="required">*</span></label>
                                                            <input type="text" className={`form-control ${errors[config.id] ? 'is-invalid' : ''}`} placeholder="Enter Area" maxLength={100} value={config.area_name}
                                                            onChange={(e) => handleChange(config.id, e.target.value)} />
                                                            {errors[config.id] && (<div className="invalid-feedback">{errors[config.id]}</div>)}
                                                        </div>
                                                        <div className='col-lg-2 col-xs-2 mt-4  px-2 py-2'>
                                                            <div className="form-check form-switch d-flex align-items-center ">
                                                                <input className="form-check-input me-2" type="checkbox" role="switch" checked={config.status === 0} onChange={() => toggleStatus(config.id, config.sno, config.status)} disabled={config.dp === 1} />
                                                            </div>
                                                        </div>
                                                        {areaadd.length > 1 && config.dp === 0 && (
                                                            <div className="col-lg-2 col-xs-2  mb-2 px-1 py-1">
                                                                <button
                                                                    className="btn btn-danger mt-4 px-2 py-2"
                                                                    onClick={() => handleDeleteArea (config.id, config.sno)}
                                                                    data-bs-toggle="tooltip"
                                                                    data-bs-placement="top"
                                                                    title="Delete"
                                                                >
                                                                    <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                {/* {errors.no && (<div className="text-danger fs-8 mt-1">{errors.no}</div>)} */}
                                
                                <div className="mb-1 mt-1">
                                    <button
                                        className="btn btn-sm btn-primary py-1 px-2"
                                        onClick={handleAddConfig}
                                    >
                                        <span><i className="fa-solid fa-plus fs-7"></i></span>
                                        <span className='ms-2 fs-8'>Add More</span>
                                    </button>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="submit" className={`btn btn-sm btn-primary ${loading ? 'disabled' : ''}`} onClick={handleSubmit}>{loading ? 'Loeading...' : 'Add Area'} <i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditArea;
